import { ModalProps } from "./types";
import { useRef, useState } from "react";
import ClearOutlinedIcon from "@mui/icons-material/ClearOutlined";
import { StyledModal, StyledOverlay, StyledModalBorder } from "./style";

function Modal({
  closeModal,
  children,
  title,
  titleColor,
  titleSize,
  subtitle,
  subtitleColor,
  subtitleSize,
  modalColor,
  modalBorderColor,
  style,
  fontFamily = "sans-serif",
}: ModalProps) {
  const [animationClass, setAnimationClass] = useState("");
  const overlayRef = useRef(null);

  const closeModalHandler = () => {
    setAnimationClass("fadeout");
    if (overlayRef.current) {
      closeModal();
      (overlayRef.current as HTMLElement).style.opacity = "0";
    }
  };

  const onAnimationEnd = (e: React.AnimationEvent<HTMLElement>) => {
    if (
      overlayRef.current &&
      (overlayRef.current as HTMLElement).style.opacity === "0"
    ) {
      (overlayRef.current as HTMLElement).style.display = "none";
    }
  };

  return (
    <StyledOverlay
      ref={overlayRef}
      onAnimationEnd={onAnimationEnd}
      className={animationClass}
      style={style}
    >
      <StyledModalBorder
        colorOne={modalBorderColor!.colorOne}
        colorTwo={modalBorderColor!.colorTwo || modalBorderColor!.colorOne}
      >
        <StyledModal
          animate={{ scale: [0, 1], rotate: [12, 0] }}
          transition={{ duration: 0.5 }}
          className={animationClass}
          colorOne={modalColor!.colorOne}
          colorTwo={modalColor!.colorTwo || modalColor!.colorOne}
          fontFamily={fontFamily}
          headerColorOne={titleColor!.colorOne}
          headerColorTwo={titleColor!.colorTwo || titleColor!.colorOne}
        >
          <ClearOutlinedIcon
            onClick={closeModalHandler}
            className='closeButton'
          />
          <h2 style={{ fontSize: `${titleSize}px` }}>
            {title}
          </h2>
          <h5 style={{ color: subtitleColor, fontSize: `${subtitleSize}px` }}>
            {subtitle}
          </h5>
          {children}
        </StyledModal>
      </StyledModalBorder>
    </StyledOverlay>
  );
}

export default Modal;
